import { fallbackInterestRates } from 'axl-config';

// sonar-disable-next-line javascript:S3776
async function applyTenantCalculatorConfigs() {
  let externalConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let listing = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    supportedDealTypes: _supportedDealTypes,
    selectedCriteria: {
      financeTermOptions: _financeTermOptions,
      selectedCreditType: _selectedCreditType
    } = {},
    ecommerce = '',
    dealerId: _dealerId,
    digitalRetailingType: _digitalRetailingType,
    disableTrade: _disableTrade,
    disclaimerKey: _disclaimerKey,
    disableUDS: _disableUDS,
    enableBOACreditAppForm: _enableBOACreditAppForm,
    enableCreditApp: _enableCreditApp,
    enableCreditVerification: _enableCreditVerification,
    enableDealReceipt: _enableDealReceipt,
    enableNegotiation: _enableNegotiation,
    enableOfferUpgrades: _enableOfferUpgrades,
    enablePayoffQuote: _enablePayoffQuote,
    enablePriceDetailsInOfferBreakdown: _enablePriceDetailsInOfferBreakdown,
    enableTaxesAndFees: _enableTaxesAndFees,
    esntialDeepLink: _esntialDeepLink,
    hideSendOfferCTA: _hideSendOfferCTA,
    includeNewVehicleIncentives: _includeNewVehicleIncentives,
    includeTaxesAndFees: _includeTaxesAndFees,
    isSingleColumn: _isSingleColumn,
    digitalRetailCTALabel: _digitalRetailCTALabel,
    partnerId: _partnerId,
    showLenderDisclaimer: _showLenderDisclaimer,
    showLenderName: _showLenderName,
    showLendingOptions: _showLendingOptions,
    showNationalAvg: _showNationalAvg,
    showMsrp: _showMsrp,
    showRatesTable: _showRatesTable,
    sponsor: _sponsor
  } = externalConfig;
  const {
    type = 'Used'
  } = listing;
  const isNewVehicle = type ? type.toLowerCase() === 'new' : false;
  let supportedDealTypes = _supportedDealTypes;
  let dealerId = _dealerId;
  let digitalRetailingType = _digitalRetailingType;
  let disableCreditTierSelection = false;
  let disableTrade = _disableTrade;
  let disclaimerKey = _disclaimerKey;
  let enableCreditApp = _enableCreditApp;
  let enableBOACreditAppForm = _enableBOACreditAppForm || false;
  let enableCreditVerification = _enableCreditVerification;
  let enableDealReceipt = _enableDealReceipt;
  let enableExternalPaymentFetch = false;
  let enableNegotiation = _enableNegotiation;
  let enableOfferUpgrades = _enableOfferUpgrades;
  let enablePayoffQuote = _enablePayoffQuote;
  let enablePriceDetailsInOfferBreakdown = _enablePriceDetailsInOfferBreakdown;
  let enableTaxesAndFees = _enableTaxesAndFees || _includeTaxesAndFees;
  let enableWalletByDefault = false;
  const esntialDeepLink = _esntialDeepLink;
  let financeTermOptions = _financeTermOptions;
  let hideCTAs = false;
  let hideSendOfferCTA = _hideSendOfferCTA;
  let includeNewVehicleIncentives = _includeNewVehicleIncentives;
  let includeTaxesAndFees = _includeTaxesAndFees;
  let isSingleColumn = _isSingleColumn;
  let digitalRetailCTALabel = _digitalRetailCTALabel;
  let partnerId = _partnerId;
  let selectedCreditType = _selectedCreditType || 'verygood';
  let showLenderDisclaimer = _showLenderDisclaimer;
  let showLenderName = _showLenderName;
  let showLendingOptions = _showLendingOptions;
  let showNationalAvg = _showNationalAvg;
  let showMsrp = _showMsrp;
  let showRatesTable = _showRatesTable;
  let sponsor = _sponsor;
  let modifiedConfig = {};
  let isUDSStandAlone = false;
  let boaDealerID = null;
  let includeDealerAndLenderFees = false;
  switch (ecommerce // tenant level defaults
  ) {
    case 'CoxAuto':
      enableExternalPaymentFetch = true;
      enableWalletByDefault = true;
      if (_supportedDealTypes === undefined) {
        supportedDealTypes = ['finance', 'cash'];
      }
      // must be set before _enableOfferUpgrades
      if (_showMsrp === undefined) {
        showMsrp = false;
      }
      if (_digitalRetailingType === undefined) {
        digitalRetailingType = 'default';
      }
      if (_disclaimerKey === undefined) {
        disclaimerKey = 'CoxAuto';
      }
      if (_enableCreditVerification === undefined) {
        enableCreditVerification = false;
      }
      if (_enableDealReceipt === undefined) {
        enableDealReceipt = false;
      }
      if (_enableNegotiation === undefined) {
        enableNegotiation = false;
      }
      if (_enableOfferUpgrades === undefined) {
        enableOfferUpgrades = !!(isNewVehicle && showMsrp && _enableOfferUpgrades); // Display dealer discount or dealer adjustment
      }
      if (_enablePayoffQuote === undefined) {
        enablePayoffQuote = false;
      }
      if (_enablePriceDetailsInOfferBreakdown === undefined) {
        enablePriceDetailsInOfferBreakdown = true;
      }
      if (_esntialDeepLink?.href && _esntialDeepLink?.label === undefined) {
        esntialDeepLink.label = 'Start purchase';
      }
      if (_financeTermOptions === undefined) {
        financeTermOptions = [24, 36, 48, 60, 72];
      }
      if (_hideSendOfferCTA === undefined) {
        hideSendOfferCTA = true;
      }
      // include new vehicle incentives if vehicle is new
      if (_includeNewVehicleIncentives === undefined) {
        includeNewVehicleIncentives = isNewVehicle; // Display manufacturer Offer and also controls retail engine request params.
      }
      if (_includeTaxesAndFees === undefined) {
        includeTaxesAndFees = true; // Calculate taxes and fees on load
        enableTaxesAndFees = true; // Display taxes and fees button or See Details link
      }
      if (_isSingleColumn === undefined) {
        isSingleColumn = true; // Show single column layout
      }
      if (_showLenderDisclaimer === undefined) {
        showLenderDisclaimer = false;
      }
      // don't include lender name unless requested
      if (_showLenderName === undefined) {
        showLenderName = false;
      }
      if (_showLendingOptions === undefined) {
        showLendingOptions = false;
      }
      if (_showNationalAvg === undefined) {
        showNationalAvg = false;
      }
      if (_showRatesTable === undefined) {
        showRatesTable = false;
      }
      break;
    case 'Accelerate':
      includeDealerAndLenderFees = true;
      if (_digitalRetailingType === undefined) {
        digitalRetailingType = 'accelerate';
      }
      if (_disclaimerKey === undefined) {
        disclaimerKey = 'Accelerate';
      }
      if (_enableCreditApp === undefined) {
        enableCreditApp = true;
      }
      if (_enableCreditVerification === undefined) {
        enableCreditVerification = false;
      }
      if (_enableDealReceipt === undefined) {
        enableDealReceipt = true;
      }
      if (_enableNegotiation === undefined) {
        enableNegotiation = false;
      }
      if (_enableOfferUpgrades === undefined) {
        enableOfferUpgrades = true;
      }
      if (_enablePayoffQuote === undefined) {
        enablePayoffQuote = false;
      }
      if (_enablePriceDetailsInOfferBreakdown === undefined) {
        enablePriceDetailsInOfferBreakdown = true;
      }
      if (_enableTaxesAndFees === undefined) {
        enableTaxesAndFees = false;
      }
      if (_includeNewVehicleIncentives === undefined) {
        includeNewVehicleIncentives = true;
      }
      if (_includeTaxesAndFees === undefined) {
        includeTaxesAndFees = false;
      }
      if (_isSingleColumn === undefined) {
        isSingleColumn = true;
      }
      if (_digitalRetailCTALabel === undefined) {
        digitalRetailCTALabel = 'Next: Calculate Taxes & Fees';
      }
      if (_partnerId === undefined) {
        partnerId = 'MMD';
      }
      if (_showMsrp === undefined) {
        showMsrp = isNewVehicle; // Show MSRP for new vehicles only
      }
      if (_showLenderDisclaimer === undefined) {
        showLenderDisclaimer = false;
      }
      if (_showLenderName === undefined) {
        showLenderName = true;
      }
      if (_showNationalAvg === undefined) {
        showNationalAvg = false;
      }
      if (_showRatesTable === undefined) {
        showRatesTable = true;
      }
      break;
    case 'PSX':
      enableWalletByDefault = true;
      isUDSStandAlone = true;
      hideCTAs = true;
      if (_dealerId === undefined) {
        dealerId = 'psx20';
      }
      if (_digitalRetailingType === undefined) {
        digitalRetailingType = 'psx';
      }
      if (_disableTrade === undefined) {
        disableTrade = true;
      }
      if (_disclaimerKey === undefined) {
        disclaimerKey = 'PSX';
      }
      if (_enableCreditVerification === undefined) {
        enableCreditVerification = true;
      }
      if (_enableDealReceipt === undefined) {
        enableDealReceipt = false;
      }
      if (_enableNegotiation === undefined) {
        enableNegotiation = true;
      }
      if (_enablePayoffQuote === undefined) {
        enablePayoffQuote = false;
      }
      if (_enablePriceDetailsInOfferBreakdown === undefined) {
        enablePriceDetailsInOfferBreakdown = false;
      }
      if (_enableTaxesAndFees === undefined) {
        enableTaxesAndFees = false;
      }
      if (_includeNewVehicleIncentives === undefined) {
        includeNewVehicleIncentives = false;
      }
      if (_includeTaxesAndFees === undefined) {
        includeTaxesAndFees = false;
      }
      if (_isSingleColumn === undefined) {
        isSingleColumn = false;
      }
      if (_partnerId === undefined) {
        partnerId = 'AMK';
      }
      if (_showLenderDisclaimer === undefined) {
        showLenderDisclaimer = false;
      }
      if (_showLenderName === undefined) {
        showLenderName = true;
      }
      if (_showLendingOptions === undefined) {
        showLendingOptions = true;
      }
      if (_showMsrp === undefined) {
        showMsrp = false;
      }
      if (_showNationalAvg === undefined) {
        showNationalAvg = true;
      }
      if (_showRatesTable === undefined) {
        showRatesTable = true;
      }
      break;
    case 'BOA':
      boaDealerID = 4016303902; // BOA specific dealer ID only for retail engine for both QA and PROD
      disableCreditTierSelection = true; // Disable credit tier selection for BOA. Excellent is the only valid credit tier
      selectedCreditType = 'excellent'; // default BOA to excellent
      enableBOACreditAppForm = true;
      includeDealerAndLenderFees = true;
      if (_digitalRetailingType === undefined) {
        digitalRetailingType = 'accelerate';
      }
      if (_disclaimerKey === undefined) {
        disclaimerKey = 'BOA';
      }
      if (_isSingleColumn === undefined) {
        isSingleColumn = false;
      }
      if (_enableDealReceipt === undefined) {
        enableDealReceipt = true;
      }
      if (_showMsrp === undefined) {
        showMsrp = isNewVehicle; // Show MSRP for new vehicles only
      }
      if (_includeTaxesAndFees === undefined) {
        includeTaxesAndFees = false;
      }
      if (_enableNegotiation === undefined) {
        enableNegotiation = false;
      }
      if (_enableTaxesAndFees === undefined) {
        enableTaxesAndFees = true;
      }
      if (_enablePriceDetailsInOfferBreakdown === undefined) {
        enablePriceDetailsInOfferBreakdown = true;
      }
      if (_enablePayoffQuote === undefined) {
        enablePayoffQuote = false;
      }
      if (_includeNewVehicleIncentives === undefined) {
        includeNewVehicleIncentives = true;
      }
      if (_showLenderName === undefined) {
        showLenderName = true;
      }
      if (_showNationalAvg === undefined) {
        showNationalAvg = false;
      }
      if (_hideSendOfferCTA === undefined) {
        hideSendOfferCTA = true;
      }
      if (_partnerId === undefined) {
        partnerId = 'BOA';
      }
      if (_sponsor === undefined) {
        sponsor = 'boa';
      }
      break;
    default:
      showLenderDisclaimer = false;
      showRatesTable = false;
  }

  // rename configs for external product config properties UDS doesn't need to know about
  const disableIncentives = !includeNewVehicleIncentives;
  delete externalConfig.includeNewVehicleIncentives;
  modifiedConfig = {
    ...externalConfig,
    selectedCriteria: {
      ...(externalConfig?.selectedCriteria || {}),
      financeTermOptions,
      selectedCreditType
    },
    supportedDealTypes,
    listing,
    dealerId,
    digitalRetailingType,
    disableCreditTierSelection,
    disableIncentives,
    disableTrade,
    disclaimerKey,
    enableBOACreditAppForm,
    enableCreditVerification,
    enableDealReceipt,
    enableExternalPaymentFetch,
    enableNegotiation,
    enableOfferUpgrades,
    enablePayoffQuote,
    enablePriceDetailsInOfferBreakdown,
    enableTaxesAndFees,
    enableWalletByDefault,
    esntialDeepLink,
    hideCTAs,
    hideSendOfferCTA,
    includeTaxesAndFees,
    interestRates: fallbackInterestRates,
    isSingleColumn,
    digitalRetailCTALabel,
    partnerId,
    showLenderDisclaimer,
    showLenderName,
    showLendingOptions,
    showNationalAvg,
    showMsrp,
    showRatesTable,
    sponsor,
    enableCreditApp,
    disableUDS: _disableUDS ?? false,
    isUDSStandAlone,
    ...(boaDealerID && {
      boaDealerID
    }),
    includeDealerAndLenderFees
  };
  return modifiedConfig;
}
export { applyTenantCalculatorConfigs as default };
